import { ChartRenderData } from "@/modules/Dashboards/AdminDashboard/models/ChartRenderData";
import { AccessOptions } from "../models/AccessOptions";

export const GENERAL_CONSTANTS = {
  DELETE_REASON_LIST_NAME: "Motivo de eliminacion",
  EXTRA_OPTION: "Otro",
  ASSIGN_TYPES_LIST: ["Completo", "Personalizado"],
  SERVICE_TYPES: {
    GROUP_TYPE: "groups",
    GROUP_TEXT: "Grupo",
    SECTION_TYPE: "sections",
    SECTION_TEXT: "Sección"
  },
  ASSIGN_TYPE: {
    COMPLETE: "Completo",
    CUSTOMIZED: "Personalizado"
  },
  TEXTS: {
    LOAD_MORE_OPTIONS: "Cargar más opciones",
    WARNING: "Advertencia",
    WARNING_DELETED_MESSAGE: " Este elemento ha sido inactivado",
    WARNING_DELETED_ELEMENTS_INSIDE_TEMPLATE:
      "Esta plantilla contiene elementos que han sido inactivados",
    NO_MULTIPLE_INSTANCES:
      "Este servicio no puede ser instanciado más de una vez.",
    NOT_ALLOWED: "No permitido",
    NEW_VERSION: "Una actualización está disponible",
    UPDATE: "Actualizar",
    SKIP_WAITING: "SKIP_WAITING",
    SW_UPDATED: "swUpdated"
  },
  ICONS: {
    ADD: "mdi-plus-circle-outline",
    CANCEL: "mdi-undo",
    COPY_FORM: "mdi-content-duplicate",
    DELETE: "mdi-delete-outline"
  },
  FORBIDDEN: "Request failed with status code 403",
  V_ON_EVENTS: {
    SERVICE_TO_ASSIGN: "serviceToAssign",
    CLOSE_ASSIGN_SERVICE: "handleCloseAssignService"
  },
  MESSAGE_NAME_USED: "El nombre ingresado ya está en uso",
  MESSAGE_EMAIL_USED: "El correo ingresado ya está en uso",
  ROUTES: {
    HOME: "Home",
    GO_TO: "Volver al "
  },
  CALL_ORIGIN: "internalPanel"
};

export const FILE_SIZE = 2000000;

export const IMG_TYPE = {
  png: "/png",
  jpg: "/jpeg"
};
export const FILE_TYPE = {
  csv: ".csv",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  wpsXlsx: "application/wps-office.xlsx"
};
export const FILE_EXTENSIONS = {
  csv: "csv",
  xls: "xls",
  xlsx: "xlsx"
};

export const TYPES_ALLOWED = [`image${IMG_TYPE.png}`, `image${IMG_TYPE.jpg}`];
export const TYPES_FILE_ALLOWED = [
  `${FILE_TYPE.csv}`,
  `${FILE_TYPE.xls}`,
  `${FILE_TYPE.xlsx}`,
  `${FILE_TYPE.wpsXlsx}`
];
export const EXTENSIONS_FILE_ALLOWED = [
  `${FILE_EXTENSIONS.csv}`,
  `${FILE_EXTENSIONS.xls}`,
  `${FILE_EXTENSIONS.xlsx}`
];

export const MANAGED_LISTS_TYPES = {
  ICONS: "icons",
  IMAGES: "images",
  NAMEOF_TYPELIST: "Categorías de listas",
  IDOF_TYPELIST: "SLgxe4UcYKdD8n0cvkFL"
};

export const GENERAL_EVENTS = {
  CLICK: "click",
  UPDATE_FIELD: "updateField"
};

export const EXCEL_CONSTANTS = {
  SHEET_NAME: "Información",
  ADMIN_DASHBOARD: "admindashboard",
  BUFFER_TYPE: "application/octet-stream"
};

export const OBJECT = "object";

export const getKeyValue = <U extends keyof T, T extends object>(key: U) => (
  obj: T
) => obj[key];

export const STORE_CONSTANTS = {
  TO_MAIN_VIEW: "setDataToMainView",
  TO_LATERAL_MENU: "setDataToLateralMenu",
  REFRESH_PROFILE_SERVICES: "setRefreshProfileServices",
  TASK_REFRESH: "setTaskRefreshing",
  NOTIFICATIONS: "setNotifications",
  SNACKBAR_MESSAGE: "setSnackbarMessage",
  PROFILE_CRUMBS: "setProfileCrumbs",
  SERVICE_CHANGE_VALIDATION: "setOnChangeServiceValidation",
  REFRESH_SERVICE_TEMPLATE: "setRefreshTemplateService",
  GENERAL_DATA_TASKS: "setGeneralDataTasks",
  DASHBOARD_SEARCH_NAME: "setDashBoardNameSearch",
  REFRESH_GROUP_SERVICE: "setGroupServiceRefresh",
  CAMPUS_SERVICE_TEMPLATE: "setCampusServiceTemplate",
  TO_CALL_ORIGIN: "setCallOrigin",
  USER_STATE: "setUserState",
  MEDICAL_ORDER_VALIDATION: "setMedicalOrderValidation",
  MEDICAL_ORDER_LIST_OBJECT: "setMedicalOrderObjList",
  CHAT_ACTION: "setChatComunication",
  SET_CONSTANTS_UI: "setConstantsUI",
  FETCH_CONSTANTS_UI: "fetchConstantsUI"
};

export const PANEL_INFO_CONSTANTS = {
  FROM: {
    PANEL: "Panel",
    PROFILE: "Profile",
    DOCTOR_PROFILE: "DoctorProfile",
    CRUD: "Crud"
  },
  TYPE: {
    SERVICE: "service",
    SEARCH: "search",
    OPTIONS: "options",
    TASK: "tasks"
  },
  ACTION: {
    SHOW: "show",
    FILL: "fill",
    REFRESH: "refresh",
    HIDE: "hide",
    COMPLETE: "complete",
    DO_ON_BOTTOM_CONTEXT: "doOnBottomContext",
    DO_SEARCH_TEMPLATE: "doSearchTemplate",
    DO_SEARCH_ELEMENTS: "doSearchElements",
    SET_SEARCH_CONTEXT: "setSearchContext",
    SET_LIST_ITEM_CONTEXT: "setListItemContext",
    LOADING_CONTEXT: "loadingContext",
    LOADING_CONTEXT_AND_HIDE_CARDS: "loadingContextAndHideCards",
    LOADED_CONTEXT: "loadedContext",
    SHOW_CARD_CONTAINER: "showCardContainer",
    HIDE_CARD_CONTAINER: "hideCardContainer",
    DISABLE_SEARCH_CONTEXT: "disableSearchContext",
    SET_SELECTED_ITEM: "setSelectedItem",
    UNDO_SELECTED_ITEM: "undoSelectedItem",
    SET_SELECTED_ITEM_NULL: "setSelectedItemNull",
    RESET_SEARCH_CONTEXT: "resetSearchContext",
    SHOW_ADD_LIST: "showAddList",
    SHOW_ADD_USER_TEMPLATE: "showAddUserTemplate",
    SHOW_ADD_ROLE: "showAddRole",
    SHOW_COMPLETE_BTN: "showCompleteBtn",
    MODAL_CAN_NOT_DELETE: "modalCanNotDelete",
    MODAL_CANCEL: "modalCancel",
    MODAL_DELETE: "modalDelete",
    MODAL_SAVE: "modalSave",
    UPDATE_MODAL: "updateModalContext",
    FUNTION_MODAL: "functionModal",
    OPEN_LATERAL_PANEL: "openLateralPanel",
    SHOW_ADD_DEPENDENCIES: "showAddDependencies",
    SHOW_ADD_CAMPUS: "showAddCampus",
    SHOW_CRUD_SAVE: "showCrudSave",
    CANCEL_SERVICE: "cancelService"
  }
};

export const OPTIONS_LOCALE_DATE: {
  timeZone: "America/Bogota";
  hour12: boolean;
  hour: "2-digit";
  minute: "2-digit";
  second: "2-digit";
  year: "numeric";
  month: "2-digit";
  day: "2-digit";
} = {
  timeZone: "America/Bogota",
  hour12: true,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
};

export const PORCENTAJE_OPERATORS_OBJ = {
  GREATER_THAN: { name: "Mayor o igual", key: ">=" },
  LESS_THAN: { name: "Menor o igual", key: "<=" }
};

export const DATE_OPERATORS_OBJ = {
  EQUAL: { name: "Igual a", key: "==", type: "operators" },
  GREATER_THAN_OR_EQUALS: { name: "Desde", key: ">=", type: "operators" },
  LESS_THAN_OR_EQUALS: { name: "Antes de", key: "<=", type: "operators" },
  BETWEEN: { name: "Entre", key: "range", type: "operators" }
};

export const DATE_OPERATORS = [
  DATE_OPERATORS_OBJ.EQUAL,
  DATE_OPERATORS_OBJ.GREATER_THAN_OR_EQUALS,
  DATE_OPERATORS_OBJ.LESS_THAN_OR_EQUALS,
  DATE_OPERATORS_OBJ.BETWEEN
];

export const OPERATORS_FILTERS = [{ name: "=", key: "==", type: "operators" }];
export const KEYTYPE_CONSTANTS = {
  GROUPS: "groups",
  OBJECT: "object",
  DEEPLEVEL: "deepLevel",
  UNDEFINED: "undefined",
  BOOLEAN: "boolean"
};

export const ROUTES = {
  HOME: "/",
  CATEGORIES_STATS: "/categories-stats"
};

export const CHART_TYPES = [
  { name: "Barras", value: "bar", icon: "mdi-chart-bar" },
  {
    name: "Barras horizontales",
    value: "horizontal-bar",
    icon: "mdi-chart-bar"
  },
  { name: "Dona", value: "doughnut", icon: "mdi-chart-arc" },
  { name: "Línea", value: "line", icon: "mdi-chart-line" },
  { name: "Torta", value: "pie", icon: "mdi-chart-pie" }
];

export const DASHBOARD_CHART_TYPES = [
  { name: "Barras", value: "bar", icon: "mdi-chart-bar", stacked: false },
  {
    name: "Barras horizontales",
    value: "horizontal-bar",
    icon: "mdi-chart-bar",
    stacked: false
  },
  { name: "Dona", value: "doughnut", icon: "mdi-chart-arc", stacked: false },
  { name: "Torta", value: "pie", icon: "mdi-chart-pie", stacked: false },
  { name: "Línea", value: "line", icon: "mdi-chart-line", stacked: false },
  {
    name: "Columnas Apiladas",
    value: "stackedColumn",
    icon: "mdi-chart-bar-stacked",
    stacked: true
  },
  {
    name: "Columnas Apiladas Horizontales",
    value: "horizontal-stackedColumn",
    icon: "mdi-chart-bar-stacked",
    stacked: true
  },
  {
    name: "Lineas Apiladas",
    value: "stackedLine",
    icon: "mdi-chart-timeline",
    stacked: true
  },
  {
    name: "Polar Apilado",
    value: "stackedPolar",
    icon: "mdi-chart-donut-variant",
    stacked: true
  },
  {
    name: "Radial Apilado",
    value: "stackedRadial",
    icon: "mdi-chart-donut",
    stacked: true
  }
];

export const BASIC_CHART_DATA: ChartRenderData = {
  labels: [],
  datasets: [
    {
      data: []
    }
  ]
};
export const COMPONENT_TAGS = ["radio", "checkbox"];

export const BASICO = "basico";
export const LIST = "lista";
export const INPUT_TYPES = ["integer", "string"];
export const STRING_TYPE = "string";

export const MAXIMUM_VALUE = "Valor mínimo es 1";

export const MINIMUM_VALUE = "Valor mínimo es 0";
export const MIN_LENGTH_PASSWORD =
  "La contraseña debe tener al menos 8 caracteres";

export const STATE = {
  ACTIVE: "Activo",
  INACTIVE: "Inactivo"
};

export const ACCESS_OPTIONS_TRUE: AccessOptions = {
  all: true,
  post: true,
  put: true,
  delete: true,
  get: true
};

export const COLORS_PALETTE = [
  "#B563F9",
  "#EBB82A",
  "#179E91",
  "#68C8E5",
  "#6616AA",
  "#F7A072",
  "#3CD6C7",
  "#2586AC",
  "#9B5897",
  "#FEC2B1",
  "#B0E3F3",
  "#C2FCF4"
];

export const NAME_FINDERS = {
  TASK_CONTEXTUAL: "searchTask",
  USER_DEPENDENCI: "searchUserDependecy",
  USER_SEARCH_CONTEXTUAL: "searchUserTimeLine",
  USER_MEDICAL_ORDEN: "searchMedicalOrden",
  PATIENT_SEARCH_NADBAR: "searchPatientNadbar",
  USER_ASSIGN_TASK: "searchAssignTask",
  SERVICE_CONTEXTUAL: "searchServiceContextual",
  NOTIFICATION_CONTEXTUAL: "searchNotificationContextual",
  ADMIN_DASHBOARD: "searchBarAdminDashboard",
  DEPENEDENCIES: "searchBarDependencies",
  LIST_DOCUMENT: "searchBarListDocument",
  LIST_EVENT: "searchBarListEvent",
  CONTEXT_PANEL: "searchBarContextPanel",
  MEDICAL_ORDER: "searchBarMedicalOrder",
  ASSIGNE_SERVICE: "searchBarAssignService",
  FORM_ACTION_PLAN: "searchBarFormActionPlan",
  GROUP_ADDSECTIONGROUP: "searchBarGroupAddSectionGroup",
  SECTION_ADDSECTIONGROUP: "searchBarSectionAddSectionGroup",
  FIND_FORM_TEMPLATE: "searchBarFindFormTemplate",
  ADD_FORM_TEMPLATE: "searchBarFormTemplate",
  AVAILABILITY: "searchBarAvailability",
  CAMPUS: "searchBarCampus",
  SPACE: "searchBarSpace"
};

export const METHODS = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE"
};

export const LIST_COLLECTIONS = [
  { key: "medicalAppointments", name: "Cita Médica" },
  { key: "services", name: "Servicios" },
  { key: "medicalOrders", name: "Orden Médica" },
  { key: "users", name: "Usuarios" },
  { key: "forms", name: "Formularios" },
  { key: "tasks", name: "Tareas" },
  { key: "sessions", name: "Sesiones" }
];

export const DATE_LOCALE = "es-co";

export const GENERATED_BY_RULE_ORDER = "Generado por la regla: ";

export const MDI_SUB = "mdi";

export const DOCUMENT_TYPE = "DOCUMENT";

export const ALPHANUMERIC_CHARACTERS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

export const SPECIAL_CHARS_REGEX = [
  ".",
  "¿",
  "?",
  "*",
  "+",
  "(",
  ")",
  "[",
  "]",
  "{",
  "}",
  "|",
  "^",
  "$",
  "-"
];

export const REGEX_NUMBER = /^[0-9]*$/;

export const SOCKET_TOPICS = {
  NEW_EVENT: "newEvent",
  MEDICALAPPOINTMENT_CHANGED: "medicalAppointmentChange",
  AVAILABILITY_CHANGED: "availabilityChange"
};

export const UI_CONFIG_MODULES = {
  AVAILABILITIES: "availabilities"
};
